import { fmtDuration, fmtStopwatch } from '../utils/format';

const RADIUS = 96;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

interface PointsRingProps {
  elapsedSeconds: number;
  minStayMinutes: number | null;
}

/** Progress ring of the stay against the minimum for full points. */
export function PointsRing({
  elapsedSeconds,
  minStayMinutes,
}: PointsRingProps) {
  const fraction = minStayMinutes
    ? Math.min(elapsedSeconds / (minStayMinutes * 60), 1)
    : 1;
  const offset = CIRCUMFERENCE * (1 - fraction);

  return (
    <div className="pv-ring">
      <svg
        width="220"
        height="220"
        viewBox="0 0 220 220"
        role="img"
        aria-label={`Progresso da permanência: ${Math.round(fraction * 100)}%`}
      >
        <circle cx="110" cy="110" r={RADIUS} className="pv-ring__track" />
        <circle
          cx="110"
          cy="110"
          r={RADIUS}
          className="pv-ring__bar"
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={offset}
          transform="rotate(-90 110 110)"
        />
      </svg>
      <div className="pv-ring__center">
        <span className="pv-muted pv-small">Tempo no local</span>
        <span className="pv-ring__time">{fmtStopwatch(elapsedSeconds)}</span>
        {minStayMinutes ? (
          <span className="pv-muted pv-small">
            de {fmtDuration(minStayMinutes)} mínimas
          </span>
        ) : null}
      </div>
    </div>
  );
}
